<template>
    <div>
      <!--<img src="/static/img/app/logo_gorsh.svg?v=1.0" class="logo-login" />-->
      <img src="/static/img/app/logom.png?v=1.0" class="logo-login" />

      <div v-show="!configLoading" class="table">
        <div class="cell">

          <div class="box-login" v-if="catalogEnabled">
            <form method="post" @submit.prevent="loginForm" lang="es">

              <h4>CARRITO</h4>
              <h1>Experimentá el color de MARTA ROGGIERO.</h1>
              <p>
                Accedé para ver todos los beneficios
              </p>
              <p style="color: red">
                {{error}}
              </p>

              <input class="usuario" name="user" type="text" placeholder="Username" v-model="email" />

              <div>
                <input class="password" name="pass" :type="passwordType" placeholder="Password" v-model="password"  />
                <i class="far fa-eye" @click.prevent="switchPasswordType" id="togglePassword" style="margin-left: 95%;cursor: pointer;margin-top: -36px;"></i>
              </div>

              <br><br>
              <input type='submit' class="submit btn-comenzar" value="INGRESAR" name='boton'>

              <ul class="login-links">

              </ul>


            </form>
          </div>

        <div class="box-login" v-else-if="configLoading">
        </div>
        <div class="box-login" v-else>
          <h1 style="color: red">
            Estamos realizando actualizaciones del sitio, regresaremos pronto...
          </h1>

        </div>

        </div>
      </div>

      <div class="PortraitBackgroundImage"  ref="backgroundElement"></div>
      </div>

    </div>
</template>

<script>

    import Mobile from './../mixing/mobile'
    import Api from '@/Api'

    export default {
        name: "LoginPage",
        data: function () {
          return {
            passwordType:'password',
            email: '',
            configLoading:true,
            catalogEnabled:false,
            password: '',
            error: '',
            pending: false,
            backgroundImage: null,
          };
        },
        computed: {
          backgroundImageStyle() {
              return {
                backgroundImage: `url(${this.backgroundImage})`
              };
          }
        },
      watch: {
        backgroundImage(newValue) {
          if (newValue) {
            this.$nextTick(() => {
              this.updateBackgroundImage();
            });
          }
        }
      },
      mixins: [Mobile],
        methods:{
          updateBackgroundImage() {
            if (this.backgroundImage && this.$refs.backgroundElement) {
              this.$refs.backgroundElement.style.backgroundImage = `url(${this.backgroundImage})`;
              this.$refs.backgroundElement.style.backgroundPosition = 'center center';
              this.$refs.backgroundElement.style.backgroundRepeat = 'no-repeat';
              this.$refs.backgroundElement.style.backgroundSize = 'cover';
            }
          },
          switchPasswordType(){
            this.passwordType = (this.passwordType==="password")?"text":"password";
          },
          loginForm(){
            this.error = "";
            this.pending = true;

            this.$store.dispatch('login', this)
              .then(() => {
                this.pending = false;
                this.$router.push({name: 'Home'});
              })
              .catch(err => {
                console.log(err);
                this.pending = false;
                this.error = err;
            });
          }
        },
        mounted(){
          $('body').removeClass().addClass("login")

          Api().get('config')
          .then(({ data }) => {
                this.configLoading = false;
                this.catalogEnabled = data.enabled==="1";
                this.backgroundImage = data.background;
          }).catch((err) => {
            console.error(err);
          });

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue